import ACTION_TYPES from '../actions/actionTypes'

export default (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_SBG_DATA:
            return { ...state, sbgData: action.payload }
        case ACTION_TYPES.FETCH_USER_CLUSTER:
            return { ...state, clustersData: action.payload }
        case ACTION_TYPES.ADD_USER_CLUSTER:
            return { ...state, clustersData: action.payload }
        case ACTION_TYPES.DELETE_USER_CLUSTER:
            return { ...state, clustersData: action.payload }
        case ACTION_TYPES.UPDATE_USER_CLUSTER:
            return { ...state, clustersData: action.payload }
        default:
            return state;
    }
};